import { PropertyHistoryProps } from './';

const mapPropertyHistoryData = ({ listingData }) => {
  //
  // this is ready to process the data from the API
  //

  // const dummyEventHistory = [
  //   {
  //     date: '2021-11-26T00:59:52.824Z',
  //     price: '1,224,000',
  //     status: 'Listed For Sale',
  //     description: '',
  //     source: 'Engel & Völkers'
  //   },
  //   {
  //     date: '2022-11-26T00:59:52.824Z',
  //     price: '835,000',
  //     status: 'Sold',
  //     description: '',
  //     source: 'Engel & Völkers'
  //   },
  //   {
  //     date: '2023-11-26T00:59:52.824Z',
  //     price: '825,000',
  //     status: 'Pending Sale',
  //     description: '',
  //     source: 'Engel & Völkers'
  //   },
  // ];
  // return dummyEventHistory;
  return null;
};

export default mapPropertyHistoryData;
